import { AxiosResponse } from 'axios';
import { checkBackendVersion } from '../helpers/caching';

const versionResponseInterceptor = async function (response: AxiosResponse) {
   try {
      const versionNumber = response.headers['x-api-version'];

      checkBackendVersion(versionNumber);
   } catch {
      console.info('Failed to check version number');
   }

   return response;
};

export { versionResponseInterceptor };
